"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyContract = void 0;
const ContractMethodDefinition_1 = require("../manifest/ContractMethodDefinition");
const BaseContract_1 = require("./BaseContract");
const PolicyTemplateAbi_json_1 = __importDefault(require("./templates/PolicyTemplateAbi.json"));
const consts_1 = require("../../consts");
let SINGLETON;
/**
 * Policy Contract that contains block-specific parameters for the current blockchain.
 * Helper methods are not fully implemented but the complete definition is available.
 */
class PolicyContract extends BaseContract_1.BaseContract {
    static get INSTANCE() {
        if (!SINGLETON) {
            SINGLETON = new PolicyContract();
        }
        return SINGLETON;
    }
    static getMethods() {
        return PolicyTemplateAbi_json_1.default.methods.map((m) => ContractMethodDefinition_1.ContractMethodDefinition.fromJson(m));
    }
    constructor() {
        super(consts_1.NATIVE_CONTRACT_HASH.PolicyContract, PolicyContract.getMethods());
    }
    getFeePerByte() {
        return this.call("getFeePerByte");
    }
    getExecFeeFactor() {
        return this.call("getExecFeeFactor");
    }
}
exports.PolicyContract = PolicyContract;
